export default {
  namespaced: true,
  state: {
    invoices: [],
    count: 0,
  },
  getters: {
    invoices: (state) => state.invoices,
    count: (state) => state.count,
  },
  mutations: {
    invoices: (state, payload) => (state.invoices = payload),
    count: (state, payload) => (state.count = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("/invoice-reminder-level", {
          params: queryParams,
        })
        .then((res) => {
          commit("invoices", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    create({}, payload) {
      return this.$apiService.post("/invoice-reminder-level", payload);
    },
    show({}, id) {
      return this.$apiService.get(`/invoice-reminder-level/${id}`);
    },
    update({}, { id, data }) {
      return this.$apiService.put(`/invoice-reminder-level/${id}`, data);
    },

    destroy({}, id) {
      return this.$apiService.delete(`/invoice-reminder-level/${id}`);
    },
   
  },
};
